export const readableDateHelper = (date: string | Date) => new Date(date).toLocaleDateString();
